import Bookstores from './BookstoresContainer';
export default Bookstores;